import {Search} from '../stores/Search';
import * as serializer from './filters';

export interface QueryValueRow {
    field?;
    fromval?;
    toval?;
    op?;
    sort?;
    isdesc?;
}

export function deserialize(search: Search) {
    const outputJson = {tables: []};
    if (search.filters.size) {
        search.filtersArray.forEach(filter => {
            const table = {tableName: 'QueryValues', rows: []};
            const row = serializer.deserialize(filter, search.store.form);
            table.rows.push(row);
            outputJson.tables.push(table);
        });
    } else {
        const table = {tableName: 'QueryValues', rows: []};
        outputJson.tables.push(table);
    }
    return outputJson;
}
